// const API_URL = "http://93.127.206.64:9004";
const API_URL = "https://www.bharatcod.com";

const endPoint = {
  GETALLPRODUCT: `${API_URL}/user/getAllProductsweb`,
  ADDTOCART: `${API_URL}/user/cart/add/web`,
  VIEWCART: `${API_URL}/user/cart/view/web`,
  GETCATEGORY: `${API_URL}/admin/getcategory`,
  REMOVECART: `${API_URL}/user/cart/delete-web`,
  PLACEORDER: `${API_URL}/user/place/website`,
  CHECKOUT: `${API_URL}/user/cart/checkout/web`,
  GETBRANDS: `${API_URL}/users/getBrands`,
  RECENTVIEW: `${API_URL}/user/Viewproducts`,
  GETRECENTVIEW: `${API_URL}/user/recently-viewed/web`,
  ADDWISHLIST: `${API_URL}/user/wishlist/add/web`,
  GETWISHLIST: `${API_URL}/user/wishlist/web`,
  REMOVEWISHLIST: `${API_URL}/users/remove-wishlist`,
  GETSUBCATEGORY: `${API_URL}/user/website/search/subcategory`,
  GETCATEGORYDATA: `${API_URL}/user/website/search/category`,
  RELATEDPRODUCT: `${API_URL}/users/related-product`,
  GETOFFER: `${API_URL}/users/products/flags`,
  GETOFFERNAME: `${API_URL}/users/get-flags`,
  FILTERPRODUCT: `${API_URL}/users/sortProducts/sort`,
  UPDATECART: `${API_URL}/user/cart/update-web`,
  LOGIN: `${API_URL}/user/phone-login/website`,
  SIGNUP: `${API_URL}/users/sign-in`,
  GetProfile: `${API_URL}/users/get-user`,
  TrackOrder: `${API_URL}/users/trac-order-guest`,
  SearchProduct: `${API_URL}/users/search-product`,
  GetReview: `${API_URL}/users/get-reviews`,
  AddReviewUser: `${API_URL}/users/rate-product`,
  ProductSerchById: `${API_URL}/user/view-products`,
  GetBannerApi: `${API_URL}/admin/promotionalImages`,
  GetCouponApi: `${API_URL}/admin/getAll/coupons`,
  ApplyCouponApi: `${API_URL}/users/apply-coupon`,
  SellerLoginApi: `${API_URL}/sellers/login-seller`,
  SellerRegister: `${API_URL}/sellers/register-seller`,
  SellerAccountApi: `${API_URL}/sellers/seller-account`,
  SellerGstApi: `${API_URL}/sellers/add-gst`,
  SellerPanApi: `${API_URL}/sellers/add-pan`,
  SellerAddressApi: `${API_URL}/sellers/add-address`,
  SellerBankDetails: `${API_URL}/sellers/add-bank`,
  GetBrandWeb: `${API_URL}/user/get-all-brands`,
  GetBrandById: `${API_URL}/user/getProduct-brands`,
  GetFreeGift: `${API_URL}/user/getGiftProduct`,
  GetTrandingProduct: `${API_URL}/user/getTrendingProduct`,
  GetTopSaleProduct: `${API_URL}/user/getTopSaleProducts`
};

export default endPoint;
